import {CONFIG} from 'src/config';
import { store } from '../store'
import AndroidBridge from "src/core/AndroidBridge";
//import Swal from "sweetalert2";

let singleFlightActive = false;

function showLoading(options) {
    if (options.disableLoading) {
        return;
    }
    store.dispatch('coreShowLoading');
}

function hideLoading(options) {
    if (options.disableLoading) {
        return;
    }
    store.dispatch('coreHideLoading');
}

export default {
    send: (method, url, data, onSuccess, onError, options) => {

        if (!method) method = 'GET';
        method = method.toUpperCase();

        if (!options) options = {};

        if (options.singleFlight && singleFlightActive) {
            if (typeof onError === 'function') {
                onError({status: 0, msg: 'Ya hay una operación en curso. Espere un momento.'});
            }
            return;
        }

        if (options.singleFlight) {
            singleFlightActive = true;
        }

        showLoading(options);

        const androidBridge = new AndroidBridge();
        const isOnApp = androidBridge.appEnabled();

        const config = {
            method: method,
            headers: new Headers({
                'Content-Type': 'application/json',
                'Accept': "application/json",
                'Authorization': 'Bearer '+store.getters.AuthGetToken,
                'x-from-app': (isOnApp) ? 'app' : 'web',
            }),
        };

        if (data) {
            config.body = JSON.stringify(data);
        }

        const finalize = () => {
            hideLoading(options);
            if (options.singleFlight) {
                singleFlightActive = false;
            }
        };

        fetch(CONFIG.getWsUrl(url), config)
            .then(response => response.json())
            .then(data => {
                console.log('**************** respuesta REQUEST ****************************************');
                if (typeof data.status !== 'undefined') {
                    if (typeof onSuccess === 'function') {
                        onSuccess(data);
                    }
                }
                else if (typeof onError === 'function') {
                    onError(data);
                }
                finalize();
            })
            .catch((e) => {
                console.log('API-RequestError:'+ e);
                if (typeof onError === 'function') {
                    onError(e);
                }
                finalize();
            });
    },
    showSuccessAlert : (msg) => {
        Swal.fire({
            icon: 'success',
            title: msg,
            showConfirmButton: true,
            confirmButtonText: 'Cerrar',
            timer: 3500
        })
    },
    showErrorAlert : (msg) => {
        Swal.fire({
            icon: 'error',
            title: msg,
            showConfirmButton: true,
            confirmButtonText: 'Cerrar',
            timer: 3500
        })
    },
    showFormValidationErrors : (errors) => {
        let strError = '';
        for (let error of errors) {
            strError += error + ', ';
        }
        strError = strError.replace(/,\s*$/, "");

        Swal.fire({
            title: '',
            text: strError,
            toast: true,
            icon: 'error',
            position: 'top-end',
            showConfirmButton: true,
            timer: 4000
        })
    },
    showSuccessNotify: (title, msg) => {
        Swal.fire({
            title: title,
            text: msg,
            toast: true,
            icon: 'success',
            position: 'top-end',
            showConfirmButton: true,
            timer: 4000
        })
    },
    showErrorNotify: (title, msg) => {
        Swal.fire({
            title: title,
            text: msg,
            toast: true,
            icon: 'error',
            position: 'top-end',
            showConfirmButton: true,
            timer: 4000
        })
    },
    showConfirm: (title, msg, callbackOnSuccess, callbackOnCancel) => {
        Swal.fire({
            title: title,
            text: msg,
            icon: "warning",
            showCancelButton: true,
            buttons: [
                'Cancelar',
                'Continuar'
            ],
        }).then(function(result) {
            if (result.isConfirmed) {
                if (typeof callbackOnSuccess === 'function') callbackOnSuccess();
            }
            else {
                if (typeof callbackOnCancel === 'function') callbackOnCancel();
            }
        })
    }
}
